import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  gradientBorder: {
    position: 'relative',
    borderRadius: '0.5rem',
    padding: '1px',
    zIndex: 0,
    overflow: 'hidden',
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '-2px',
      left: '-2px',
      width: 'calc(100% + 4px)',
      height: 'calc(100% + 4px)',
      borderRadius: 'inherit',
      backgroundImage: `conic-gradient(
rgba(255, 255, 255, 0) 0%,
rgba(255, 255, 255, 0.41) 20%,
rgb(178, 133, 255) 50%,
rgba(74, 143, 253, 0.53) 66%,
rgba(255, 255, 255, 0) 100%
      )`,
      backgroundSize: '100% 100%',
      backgroundPosition: 'center',
      animation: '$spin 10s linear infinite',
      zIndex: -1,
    },

    '&::before': {
      filter: 'blur(20px)',
      zIndex: -2,
    },

    '& > *': {
      position: 'relative',
      zIndex: 1,
      borderRadius: 'inherit',
    },
  },
});


function GradientBorderDiv({ children }) {
  const classes = useStyles();

  return <div className={classes.gradientBorder}>{children}</div>;
}

export default GradientBorderDiv;
